import api from './api.js';

export const obter_grupos = async () => {
    try {
        const response = await api.get('/Categorias/Grupos');

        if(response.data.sucesso){
            return response.data.grupos;
        } else {
            throw new Error('Falha ao obter grupos.');
        }

    } catch (err){
        console.error('Erro ao obter grupos: ', err);
        throw err;
    }
};

export const obter_subgrupos = async (grupo) => {
    try {
        const response = await api.get('/Categorias/Subgrupos', {
            params: { grupo }
        });

        if(response.data.sucesso){
            return response.data.subgrupos;
        } else {
            throw new Error('Falha ao obter subgrupos.');
        }

    } catch (err){
        console.error('Erro ao obter subgrupos: ', err);
        throw err;
    }
};

export const obter_divisoes = async (grupo, subgrupo) => {
    try {
        const response = await api.get('/Categorias/Divisoes', {
            params: { grupo, subgrupo }
        });

        if(response.data.sucesso){
            return response.data.divisao;
        } else {
            throw new Error('Falha ao obter divisões.');
        }

    } catch (err){
        console.error('Erro ao obter divisões: ', err);
        throw err;
    }
};


